export enum AssetAlignmentType {
  BOTTOM = 'bottom',
  VERTICAL_CENTER = 'verticalCenter',
  HORIZONTAL_CENTER = 'horizontalCenter',
  LEFT = 'left',
  RIGHT = 'right',
  TOP = 'top',
}

export enum AssetAlignmentDirection {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}

export const AlignmentValue: Record<AssetAlignmentType, string> = {
  [AssetAlignmentType.TOP]: 'top',
  [AssetAlignmentType.HORIZONTAL_CENTER]: 'center',
  [AssetAlignmentType.BOTTOM]: 'bottom',
  [AssetAlignmentType.LEFT]: 'left',
  [AssetAlignmentType.VERTICAL_CENTER]: 'center',
  [AssetAlignmentType.RIGHT]: 'right',
};

/**
 * Now using only for text alignment inside CTA Button
 */
export const TextAlignmentStyleMap: PartialRecord<AssetAlignmentType, React.CSSProperties> = {
  [AssetAlignmentType.LEFT]: { textAlign: 'left' },
  [AssetAlignmentType.HORIZONTAL_CENTER]: { textAlign: 'center' },
  [AssetAlignmentType.RIGHT]: { textAlign: 'right' },
};
